module.exports = __webpack_public_path__ + "img/icbcAmount-icon.a5eab8d5.png";